import { render, staticRenderFns } from "./MaestroExamenes.vue?vue&type=template&id=36020582&scoped=true&"
import script from "./MaestroExamenes.vue?vue&type=script&lang=js&"
export * from "./MaestroExamenes.vue?vue&type=script&lang=js&"
import style0 from "./MaestroExamenes.vue?vue&type=style&index=0&id=36020582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36020582",
  null
  
)

export default component.exports